import React from 'react';
import { NavLink } from 'react-router-dom';
import { BLOG_CATEGORIES } from '../config/blogCategories';

const BlogCategoryNav = () => (
  <nav className="blog-category-nav" aria-label="Blog categories">
    <ul className="blog-category-nav__list">
      {BLOG_CATEGORIES.map((cat) => (
        <li key={cat.id}>
          <NavLink
            to={cat.path}
            end={cat.id === 'all'}
            className={({ isActive }) =>
              `blog-category-nav__link${isActive ? ' blog-category-nav__link--active' : ''}`
            }
          >
            {cat.shortLabel}
          </NavLink>
        </li>
      ))}
    </ul>
  </nav>
);

export default BlogCategoryNav;
